import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { error } from 'selenium-webdriver';
import { APP_ROUTES } from '../../contants/APP_ROUTES';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { AUTH } from '../../contants/AUTH';
import { AlertService } from '../../services/alert.service';
import { UserService } from '../../services/user.service';
import { Helper } from '../../helpers/Helper';
import { environment } from '../../../environments/environment';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
	username: string;
	password: string;
	form: FormGroup;
	showLoader: boolean = false;
	appVersion: string = environment.version;

	constructor(
		private _authenticationService: AuthenticationService,
		private _route: ActivatedRoute,
		private _router: Router,
		private _alertService: AlertService,
		private _userService: UserService
	) { }

	ngOnInit() {
		//reset login status if page is visited
		this._authenticationService.logout();
		this.form = this.createForm();

		
		console.log('v: ', this.appVersion);
	}

	private createForm(): FormGroup {
		return new FormGroup({
			username: new FormControl(this.username, [
				Validators.required,
				Validators.email
			]),
			password: new FormControl(this.password, [
				Validators.required
			]),
		});
	}

	onLogin(formValue) {
		if (!this.form.valid) {
			return;
		}

		this.showLoader = true;
		this._authenticationService.login(formValue.username, formValue.password).subscribe(
			data => {
				//check local storage
				let token = localStorage.getItem(AUTH.token);
				this.form.value.password = null;
				if (token == undefined) {
					this._alertService.showError('There was a problem with the authentication process, please contact your administrator');
					return;
				}

				if (token == undefined) {
					this._alertService.showError('Invalid username and password combination.');
					return;
				}

				this._userService.getCurrentUser().subscribe(
					result => {
						if(result == undefined){
							this._alertService.showGenericError();
							this._authenticationService.logout();
							this.showLoader = false;
						}
						else{
							localStorage.setItem(AUTH.userId, result.id.toString());
							localStorage.setItem(AUTH.userRole, result.employeeRole);
							localStorage.setItem(AUTH.userFullName, result.fullName);

							this.showLoader = false;
							if(Helper.isManager()){
								this._router.navigate([APP_ROUTES.dashboard]);
							}
							else if(result.employeeRole == 'BOOK_KEEPER'){
								this._router.navigate([APP_ROUTES.dashboardBookkeeper]);
							}
							else{
								this._router.navigate([APP_ROUTES.userProfile.replace('/:id', ''), 0]);
							}
						}
					}
				);
			},
			error => {
				this._alertService.showError('Invalid username and password combination.');
				this.showLoader = false;
			}
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts